import { render, staticRenderFns } from "./SubscriptionsView.vue?vue&type=template&id=b4a2d70e&scoped=true&"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsView.vue?vue&type=style&index=0&id=b4a2d70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a2d70e",
  null
  
)

export default component.exports